import * as moment from "moment";
import { ReportingService } from "@common/reporting.service";
import { ReportingParams } from "../../../reporting/reportingParams";
import { ClientRepo } from "@services/clients/client.repo";
import { ClientDetails } from "@models/clients/clientDetailsModel";
import { ClientBenchmarkColumnNames } from "@models/clients/clientBenchmarkConfig";

class GenerateReportDialogController implements ng.IOnInit {
  public reportForm: ng.IFormController;

  public restrictedDates: string[];
  public currencyList: string[] = ["MUR", "EUR", "GBP", "USD", "CHF"];
  public previousMonthLastDay: Date;
  public lastTwelveMonths: Date;
  public reportDate: any;

  public isLoading: boolean = false;

  public clientPortfolios: any;
  public clientNumber: any;
  public selectedCurrency: any;
  public selectedPortfolios: any;

  //top holdings header checkboxes
  public showTopCombinedHoldings: boolean = false;
  public showTopLocalHoldings: boolean = false;
  public showTopInternationalHoldings: boolean = false;

  //checkbox defaults(for report generation) are set in this class constructor
  public reportingParams: ReportingParams = new ReportingParams();

  public primaryBenchmarkColumnName: string =
    ClientBenchmarkColumnNames.DefaultBenchmark;
  public secondaryBenchmarkColumnName: string = "";
  public isSecondaryBenchmarkColumnEnabled: boolean = false;

  // End Benchmark columns

  public client: ClientDetails;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private notifyjs,
    private $scope: angular.IScope,
    private reportingService: ReportingService,
    private clientRepo: ClientRepo,
    private $stateParams: angular.ui.IStateParamsService
  ) {}

  $onInit() {
    let currentDate = new Date();
    this.previousMonthLastDay = new Date(
      moment(currentDate)
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD")
    );
    this.lastTwelveMonths = new Date(
      moment(currentDate)
        .subtract(18, "months")
        .endOf("month")
        .format("YYYY-MM-DD")
    );
    this.reportDate = this.previousMonthLastDay;

    this.clientRepo
      .getClient(this.clientNumber)
      .then((val) => {
        this.client = val.data as ClientDetails;
        this.primaryBenchmarkColumnName =
          this.client.primaryBenchmarkColumnName === null ||
          this.client.primaryBenchmarkColumnName === undefined
            ? ClientBenchmarkColumnNames.DefaultBenchmark
            : this.client.primaryBenchmarkColumnName;
        this.secondaryBenchmarkColumnName =
          this.client.secondaryBenchmarkColumnName === null ||
          this.client.secondaryBenchmarkColumnName === undefined
            ? ""
            : this.client.secondaryBenchmarkColumnName;
        this.isSecondaryBenchmarkColumnEnabled =
          this.client.isSecondaryBenchmarkColumnEnabled === null ||
          this.client.isSecondaryBenchmarkColumnEnabled === undefined ||
          this.isNullOrWhitespace(this.secondaryBenchmarkColumnName)
            ? false
            : this.client.isSecondaryBenchmarkColumnEnabled;
      })
      .catch((err) => {});
  }

  public isNullOrWhitespace(input: string | null | undefined): boolean {
    return !input || input.trim().length === 0;
  }

  onTopCombinedPortfoliosChanged() {
    if (this.showTopCombinedHoldings) {
      this.reportingParams.topCombinedHoldings =
        this.reportingParams.topCombinedEquityHoldings =
        this.reportingParams.topCombinedFixedIncomeHoldings =
          true;
    } else {
      this.reportingParams.topCombinedHoldings =
        this.reportingParams.topCombinedEquityHoldings =
        this.reportingParams.topCombinedFixedIncomeHoldings =
          false;
    }
  }
  onTopCombinedSubItemChanged() {
    this.showTopCombinedHoldings =
      this.reportingParams.topCombinedHoldings ||
      this.reportingParams.topCombinedEquityHoldings ||
      this.reportingParams.topCombinedFixedIncomeHoldings;
  }
  onTopLocalPortfoliosChanged() {
    if (this.showTopLocalHoldings) {
      this.reportingParams.topLocalHoldings =
        this.reportingParams.topLocalEquityHoldings =
        this.reportingParams.topLocalFixedIncomeHoldings =
          true;
    } else {
      this.reportingParams.topLocalHoldings =
        this.reportingParams.topLocalEquityHoldings =
        this.reportingParams.topLocalFixedIncomeHoldings =
          false;
    }
  }
  onTopLocalSubItemChanged() {
    this.showTopLocalHoldings =
      this.reportingParams.topLocalHoldings ||
      this.reportingParams.topLocalEquityHoldings ||
      this.reportingParams.topLocalFixedIncomeHoldings;
  }
  onTopInternationalPortfoliosChanged() {
    if (this.showTopInternationalHoldings) {
      this.reportingParams.topInternationalHoldings =
        this.reportingParams.topInternationalEquityHoldings =
        this.reportingParams.topInternationalFixedIncomeHoldings =
          true;
    } else {
      this.reportingParams.topInternationalHoldings =
        this.reportingParams.topInternationalEquityHoldings =
        this.reportingParams.topInternationalFixedIncomeHoldings =
          false;
    }
  }

  onTopInternationalSubItemChanged() {
    this.showTopInternationalHoldings =
      this.reportingParams.topInternationalHoldings ||
      this.reportingParams.topInternationalEquityHoldings ||
      this.reportingParams.topInternationalFixedIncomeHoldings;
  }

  onCombinedBenchmarkChanged() {
    if (this.reportingParams.combinedBenchmark) {
      this.reportingParams.combinedBenchmarkPrimary = true;

      this.reportingParams.combinedBenchmarkSecondary =
        this.client.isSecondaryBenchmarkColumnEnabled;
    } else {
      this.reportingParams.combinedBenchmarkPrimary =
        this.reportingParams.combinedBenchmarkSecondary = false;
    }
  }
  onCombinedBenchmarkSubItemChanged() {
    this.reportingParams.combinedBenchmark =
      this.reportingParams.combinedBenchmarkPrimary ||
      this.reportingParams.combinedBenchmarkSecondary;
  }

  onLocalBenchmarkChanged() {
    if (this.reportingParams.localBenchmark) {
      this.reportingParams.localBenchmarkPrimary = true;

      this.reportingParams.localBenchmarkSecondary =
        this.client.isSecondaryBenchmarkColumnEnabled;
    } else {
      this.reportingParams.localBenchmarkPrimary =
        this.reportingParams.localBenchmarkSecondary = false;
    }
  }
  onLocalBenchmarkSubItemChanged() {
    this.reportingParams.localBenchmark =
      this.reportingParams.localBenchmarkPrimary ||
      this.reportingParams.localBenchmarkSecondary;
  }

  onInternationalBenchmarkChanged() {
    if (this.reportingParams.internationalBenchmark) {
      this.reportingParams.internationalBenchmarkPrimary = true;

      this.reportingParams.internationalBenchmarkSecondary =
        this.client.isSecondaryBenchmarkColumnEnabled;
    } else {
      this.reportingParams.internationalBenchmarkPrimary =
        this.reportingParams.internationalBenchmarkSecondary = false;
    }
  }
  onInternationalBenchmarkSubItemChanged() {
    this.reportingParams.internationalBenchmark =
      this.reportingParams.internationalBenchmarkPrimary ||
      this.reportingParams.internationalBenchmarkSecondary;
  }

  formatDate(selectedDate) {
    return moment(selectedDate).endOf("month").format("YYYY-MM");
  }

  getLastDayOfMonth = (selectedDate) => {
    const momentDate = moment(selectedDate);
    selectedDate = momentDate.format("YYYY-MM-DD");
    let lastDayOfSelectedDate = momentDate.endOf("month").format("YYYY-MM-DD");

    return (
      lastDayOfSelectedDate !== selectedDate &&
      !this.restrictedDates.some(
        (rd) =>
          moment(rd).month() === momentDate.month() &&
          moment(rd).year() === momentDate.year()
      )
    );
  };

  previewReport = () => {
    this.isLoading = true;
    this.reportDate = moment(this.reportDate)
      .endOf("month")
      .format("MM/DD/YYYY");
    let fromDate = moment(this.reportDate).startOf("year").format("MM/DD/YYYY");
    this.reportingParams.portfolioIds = this.selectedPortfolios;
    this.reportingParams.toDate = this.reportDate;
    this.reportingParams.fromDate = fromDate;
    this.reportingParams.reportType = "portfoliosummary";
    this.reportingParams.userId = null;
    this.reportingParams.clientNumber = null;
    this.reportingParams.currency = this.selectedCurrency;
    this.reportingService
      .generateReport(this.reportingParams)
      // .then((res) => {
      //   this.isLoading = false
      // })
      .catch(() => {
        this.notifyjs(
          "The report could not be generated. Please try again later or contact the System Administrator for assistance.",
          "error"
        );
      })
      .finally(() => (this.isLoading = false));
  };

  cancel = () => {
    this.$mdDialog.hide();
  };

  saveClientReport = () => {
    this.isLoading = true;
    this.reportDate = moment(this.reportDate)
      .endOf("month")
      .format("MM/DD/YYYY");
    let fromDate = moment(this.reportDate).startOf("year").format("MM/DD/YYYY");
    this.reportingParams.toDate = this.reportDate;
    this.reportingParams.fromDate = fromDate;
    this.reportingParams.reportType = "portfoliosummary";
    this.reportingParams.clientNumber = this.clientNumber;
    this.reportingParams.userId = null;
    this.reportingParams.portfolioIds = null;
    this.reportingParams.currency = this.selectedCurrency
    this.reportingService
      .generateReport(this.reportingParams)
      .then((res) => this.$mdDialog.hide(true))
      .catch(() =>
        this.notifyjs(
          "The report could not be generated. Please try again later or contact the System Administrator for assistance.",
          "error"
        )
      )
      .finally(() => (this.isLoading = false));
  };
}

export const generateReportDialog: angular.IComponentOptions = {
  template: require("./generateMonthlyReport.dialog.html"),
  controller: GenerateReportDialogController,
  bindings: {
    selectedPortfolios: "<",
    selectedCurrency: "<",
    clientNumber: "<",
    restrictedDates: "<",
    clientPortfolios: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/reportManagement/monthlyReportDialog/generateMonthlyReport.dialog.ts